import { usePaymentContext } from "pages/payment/providers/PaymentProvider";
import { PaymentActions } from "shared/utils/payment-methods";
import CustomLink from "shared/ui/typography/CustomLink";
import Heading from "shared/ui/typography/Heading";
import Text from "shared/ui/typography/Text";

const PaymentWarrantyText = () => {
  const { warrantyDescription, warrantyTitle, hasPaid, paymentAction } =
    usePaymentContext();

  return (
    <>
      <Heading headingLevel={"h4"} className="gg-mb-3">
        {warrantyTitle}
      </Heading>
      <Text className="gg-mb-5">
        {warrantyDescription} Lees{" "}
        <a
          href="/zekerheidspakket-gewoonzeker/"
          target="_blank"
          rel="noreferrer"
          className="gg-font-bold gg-underline hover:gg-text-gray-500"
        >
          hier
        </a>{" "}
        alle voorwaarden en kleine lettertjes.
        {!hasPaid && paymentAction === PaymentActions.PAY_FULL && (
          <>
            <br />
            Bij een volledige betaling vooraf krijg je 1 jaar GewoonZeker
            (t.w.v. €39,-) cadeau!
          </>
        )}
      </Text>
    </>
  );
};
export default PaymentWarrantyText;
